/**
 * @generated SignedSource<<0127391af75bd021092953d03fd2b1f1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type UniversalCreateOrDefaultButton_fragment$data = {
  readonly jira_projectByIdOrKey?: {
    readonly projectType: JiraProjectType;
  };
  readonly " $fragmentType": "UniversalCreateOrDefaultButton_fragment";
};
export type UniversalCreateOrDefaultButton_fragment$key = {
  readonly " $data"?: UniversalCreateOrDefaultButton_fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UniversalCreateOrDefaultButton_fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "projectKey"
    },
    {
      "kind": "RootArgument",
      "name": "skipUniversalCreateQuery"
    }
  ],
  "kind": "Fragment",
  "name": "UniversalCreateOrDefaultButton_fragment",
  "selections": [
    {
      "condition": "skipUniversalCreateQuery",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Variable",
                "name": "idOrKey",
                "variableName": "projectKey"
              }
            ],
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jira_projectByIdOrKey",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "kind": "ScalarField",
                  "name": "projectType"
                },
                "action": "THROW",
                "path": "jira_projectByIdOrKey.projectType"
              }
            ]
          },
          "action": "THROW",
          "path": "jira_projectByIdOrKey"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "d4814c0dab0bb2c5552021498c33e46a";

export default node;
